import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19l16 -14","key":"svg-0"}]]

const IconStrokeStraight = createReactComponent('outline', 'stroke-straight', 'StrokeStraight', __iconNode);

export default IconStrokeStraight;